import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { setSelectedAccount } from "../../redux/userSlice";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { ROUTES } from "../../constants";
import { persistSelectedAccountId } from "../../utils/accountSelectionStorage";

const AccountSelector = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userId = useAppSelector(({ userData }) => userData.userId);
  const selectedAccountId = useAppSelector(
    ({ userData }) => userData.selectedAccount?.accountId
  );
  const accounts = useAppSelector(({ userData }) => userData.accounts);

  const handleAccountChange = (accountId: string) => {
    if (accountId === selectedAccountId) return;

    const selectedAccount = accounts?.find(
      (account) => account.accountId === accountId
    );

    if (!selectedAccount) return;

    dispatch(setSelectedAccount(selectedAccount));
    persistSelectedAccountId(userId, selectedAccount.accountId);
    navigate(ROUTES.HOME, { replace: true, state: { fromAccountSwitch: true } });
  };

  const getAccountDisplayLabel = (account: {
    accountName: string;
    createdByName?: string | null;
    createdByEmail?: string | null;
  }) => {
    const createdByName = account.createdByName?.trim();
    const createdByEmail = account.createdByEmail?.trim();

    if (createdByName && createdByEmail) {
      return `${createdByName} (${createdByEmail})`;
    }
    if (createdByName) {
      return createdByName;
    }
    if (createdByEmail) {
      return createdByEmail;
    }
    return account.accountName;
  };

  const renderOptions = () =>
    accounts?.map((account) => (
      <Select.Option
        key={account.accountId}
        value={account.accountId}
        title={getAccountDisplayLabel(account)}
      >
        {getAccountDisplayLabel(account)}
      </Select.Option>
    ));

  return (
    <div className="fp_slctr_cntnr fp_cmpnt fp_cmpnt_flx_rw">
      <p className="fp_slctr_lbl">Account :</p>
      <Select
        data-testid="fp_account_selector"
        value={selectedAccountId}
        placeholder="Select account"
        className="fp_slctr"
        onChange={handleAccountChange}
      >
        {renderOptions()}
      </Select>
    </div>
  );
};

export default AccountSelector;
